import React, { ReactNode } from 'react';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import './Tooltip.css';
import { Info } from 'lucide-react';
import { Placement } from 'tippy.js';

export interface TooltipProps {
  content: string;
  icon?: ReactNode;
  iconStyle?: React.CSSProperties;
  iconClassName?: string;
  tooltipStyle?: React.CSSProperties;
  position?: Placement;
  className?: string;
  maxWidth?: string | number;
  size?: 'xs' |'sm' | 'md' | 'lg' | 'xl';
}

export const Tooltip: React.FC<TooltipProps> = ({
  content,
  icon,
  iconStyle = {},
  iconClassName = '',
  tooltipStyle = {},
  position = 'top',
  className = '',
  maxWidth = '464px',
  size = 'md',
}) => {
  const defaultIcon = (
    <Info
      size={16}
      style={{
        color: 'var(--color-gray-400)',
        marginLeft: 'var(--spacing-1)',
        ...iconStyle,
      }}
    />
  );

  return (
    <Tippy
      content={content}
      appendTo={() => document.body} // Ensures tooltip is rendered at the body level without clipping
      placement={position}
      arrow={true}
      maxWidth={typeof maxWidth === 'number' ? maxWidth : maxWidth}
      zIndex={999999}
      theme={`custom custom-${size}`}
      className={className}
      interactive={true}
      animation="fade"
    >
      <span
        // style={{
        //   display: 'inline-flex',
        //   alignItems: 'center',
        //   cursor: 'pointer',
        //   verticalAlign: 'middle',
        // }}
        className={'inline-flex items-center cursor-pointer align-middle  ' + iconClassName}
      >
        {icon || defaultIcon}
      </span>
    </Tippy>
  );
};
